import React from 'react';

import {
  AdServer,
  ContainerId,
  type LayoutType,
  type PlacementId
} from '@schibsted-nmp/advertising-shared';

import { Intermingle } from './useIntermingles.js';

export type PositionData<
  TPlacementId extends PlacementId = PlacementId,
  TAdServer extends AdServer = AdServer
> = {
  position: number;
  placementId: TPlacementId;
  containerId: ContainerId<TPlacementId, TAdServer>;
  adServer: TAdServer;
};

export function useSearchPositionInstruction(
  layoutType: LayoutType
): ReadonlyArray<PositionData> {
  const interminglePlacements = Intermingle.List.use();

  return React.useMemo(
    () =>
      interminglePlacements
        .map<PositionData | null>(({ placementId, intermingle, adServer }) => {
          const interval = intermingle?.[layoutType];
          if (!interval) return null;

          const adServerType = adServer.type as AdServer; // Casting due to wrong API typings

          return {
            containerId: ContainerId.fromPlacementId(placementId, adServerType),
            placementId,
            position: interval,
            adServer: adServerType
          };
        })
        .filter((positionData) => positionData !== null),
    [layoutType, interminglePlacements]
  );
}
